import { useContext } from "react";

import DetailsBox from "../components/DetailsBox";
import EmptyBox from "../components/EmptyBox";
import SelectedDispute from "../components/SelectedDispute";
import { theme } from "../../../../theme";
import Context from "../context";
import { fetchJobs } from "../service";

const BodyView = () => {
    const context = useContext(Context);

    const loadMore = () => {
        if (!context.state.isEnd) {
            fetchJobs(context.dispatch, context.state.lastDoc);
        }
    };

    const handleDisputeClick = (dispute) => {
        context.dispatch({
            type: 'SET_SELECTED_DISPUTE',
            selectedDispute: dispute,
        });
    };

    return(
        <div className="row">
            <div className="col-lg-10 col-md-10 mx-auto">
                {/* Job Details Section */}
                <div className="card-body p-3">

                    <div className="row">
                        <div className="col-lg-8 col-md-7">
                            {context.state.disputes.map((dispute, index) => (
                                <DetailsBox key={index} dispute={dispute} index={index} handleDisputeClick={handleDisputeClick} />
                            ))}

                            <div className="mt-3">
                                {context.state.loading && (
                                    <div className="text-center my-3">
                                        <p>Loading...</p>
                                    </div>
                                )}

                                {!context.state.loading && !context.state.isEnd && (
                                    <div className="text-center my-3">
                                        <a
                                            href="#!"
                                            className={`text-${theme.main} font-weight-bold text-gradient`}
                                            onClick={loadMore}
                                        >
                                            Load more
                                        </a>
                                    </div>
                                )}

                                {context.state.isEnd && (
                                    <div className="text-center my-3 text-muted">
                                        <p>No more jobs to load.</p>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-7">
                            {context.state.selectedDispute === null ? <EmptyBox /> : <SelectedDispute selectedDispute={context.state.selectedDispute} />}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default BodyView;